import { TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import React, { useEffect, useState } from "react";
import styles from "./upcharge.module.scss";
import { useDelivery } from "../../../Pages/Order/Order/hooks/useDelivery";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UpchargeModel = ({
  showModal,
  pageTitle,
  handleCancelClick,
  handleClick,
  upchargeValue,
  id,
}) => {
  const [value, setValue] = useState(upchargeValue);
  useEffect(() => {
    setValue(upchargeValue);
  }, [upchargeValue]);
  const { handleUpchargeChange } = useDelivery();

  const handleSubmit = () => {
    switch (id) {
      case "upcharge":
        handleUpchargeChange(value);
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={showModal}
        TransitionComponent={Transition}
        onClose={() => {
          handleCancelClick();
        }}
        classes={{
          paper: styles.modalDialog,
        }}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogContent className={`${styles.modalContent} px-0 py-0`}>
          <div className={`text-center ${styles.modalBody}`}>
            <h5 className={`my-3 text-center ${styles.modalTitle}`}>
              Update {pageTitle}
            </h5>
            <div className="row">
              <div className={`col-md-4 col-xs-12 mt-5 ${styles.marginAuto}`}>
                <TextField
                  type="text"
                  label={pageTitle}
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                  }}
                />
              </div>
            </div>

            <span
              data-dismiss="modal"
              onClick={() => {
                handleSubmit();
                handleClick();
              }}
              className="btn gray-btn d-inline-block mt-5 mb-5 mr-2 mt-5 cursor-pointer"
            >
              Save
            </span>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default UpchargeModel;
